import {ChangeDetectionStrategy, Component, Input, Output, EventEmitter} from '@angular/core';
import {ColumnTableItem, TranspiledColumnTableItem} from '../../../../global';
import { NgIf, NgFor, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { AccessDirective } from '../../../directives/has-access.directive';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { LoaderComponent } from '../../loader/loader.component';
import { ButtonIconComponent } from '../../buttons/button-icon/button-icon.component';
import { RouterLink } from '@angular/router';
import { CurrencyTransformPipe } from '../../../pipes/currency-transform.pipe';
import { RouteParamPipe } from '../../../pipes/route-param.pipe';
import { DateTransformPipe } from '../../../pipes/date-transform.pipe';

@Component({
    selector: 'slm-vertical-table',
    templateUrl: './vertical-table.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgFor, AccessDirective, SvgIconComponent, MatTooltip, NgSwitch, NgSwitchCase, TranslateDirective, LoaderComponent, NgSwitchDefault, ButtonIconComponent, RouterLink, TranslatePipe, CurrencyTransformPipe, RouteParamPipe, DateTransformPipe]
})
export class VerticalTableComponent {
  data: any = null;
  @Input() loadingAttributes: Array<string> = [];

  @Input('data')
  set setData(data: any) {
    this.data = data;
    this.setAttribute(this.attributes);
  }

  attributes: Array<TranspiledColumnTableItem> = [];

  @Input('attributes')
  set setAttributes(attributes: Array<ColumnTableItem>) {
    this.setAttribute(attributes);
  }

  @Output() thirdColumnClicked = new EventEmitter();

  keyIsExist(key: string) {
    if (!this.data) {
      return false;
    }
    const keyIsExist = key in this.data;
    return keyIsExist && this.data[key] !== null && this.data[key] !== undefined;
  }

  setAttribute(attributes: Array<ColumnTableItem>) {
    this.attributes = attributes?.map(attribute => ({
      ...attribute,
      color: typeof attribute.valueColor === 'function' ? attribute.valueColor(this.data) : attribute.valueColor,
      thirdColumnConfig: typeof attribute.thirdColumn === 'function' ? attribute.thirdColumn(this.data) : attribute.thirdColumn
    }));
  }
}
